import Sidebar from "../../components/Sidebar";
import React, { useState, useEffect } from "react";
import axios from "axios";
import ProductCategoryAttributeValueTable from "../../components/productCategoryAttributeValue/productCategoryAttributeValueTable";
import AddProductCategoryAttributeValueModal from "../../components/productCategoryAttributeValue/AddProductCategoryAttributeValue";
import EditProductCategoryAttributeValueModal from "../../components/productCategoryAttributeValue/EditProductCategoryAttributeValue";
import PreviewProductCategoryAttributeValueModal from "../../components/productCategoryAttributeValue/PreviewProductCategoryAttributeValue";
import DeleteProductCategoryAttributeValueModal from "../../components/productCategoryAttributeValue/DeleteProductCategoryAttributeValue";

const ProductCategoryAttributeValueManagement = () => {
  const [values, setValues] = useState([]);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const valuesPerPage = 5;

  const indexOfLastValue = currentPage * valuesPerPage;
  const indexOfFirstValue = indexOfLastValue - valuesPerPage;
  const currentValues = values.slice(indexOfFirstValue, indexOfLastValue);
  const totalPages = Math.ceil(values.length / valuesPerPage);
  const [openDropdownId, setOpenDropdownId] = useState(null);

  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

  const handleDelete = async () => {
    if (selectedValue) {
      try {
        const response = await axios.delete(
          `https://api.theonlysale.com/api/product-category-attribute-values/delete/${selectedValue.value_id}`
        );
        if (response.status >= 200 && response.status < 300) {
          setIsDeleteModalOpen(false);
          fetchValues();
        } else {
          console.error("Failed to delete the value");
        }
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  useEffect(() => {
    fetchValues();
  }, []);

  const fetchValues = async () => {
    try {
      const response = await axios.get(
        `https://api.theonlysale.com/api/product-category-attribute-values/get`
      );
      setValues(response.data);
    } catch (error) {
      console.error("Error fetching values:", error);
    }
  };

  const toggleAddModal = () => setIsAddModalOpen((prev) => !prev);
  const toggleEditModal = () => setIsEditModalOpen((prev) => !prev);
  const togglePreviewModal = () => setIsPreviewModalOpen((prev) => !prev);
  const toggleDeleteModal = () => setIsDeleteModalOpen((prev) => !prev);

  const toggleDropdown = (valueId) => {
    setOpenDropdownId((prevId) => (prevId === valueId ? null : valueId));
  };

  const handleEditModalOpen = (value) => {
    setSelectedValue(value);
    setIsEditModalOpen(true);
  };

  const handlePreviewModalOpen = (value) => {
    setSelectedValue(value);
    setIsPreviewModalOpen(true);
  };

  const handleDeleteModalOpen = (value) => {
    setSelectedValue(value);
    setIsDeleteModalOpen(true);
  };

  useEffect(() => {
    document.body.classList.toggle(
      "no-scroll",
      isAddModalOpen || isEditModalOpen || isPreviewModalOpen
    );
  }, [isAddModalOpen, isEditModalOpen, isPreviewModalOpen]);

  return (
    <>
      <div className="flex min-h-screen">
        <div className="w-64">
          <Sidebar />
        </div>
        <div className="flex-grow dark:bg-gray-900">
          <ProductCategoryAttributeValueTable
            valuesLength={values.length}
            totalPages={totalPages}
            currentPage={currentPage}
            currentValues={currentValues}
            handlePageChange={handlePageChange}
            toggleModal={toggleAddModal}
            toggleDropdown={toggleDropdown}
            openDropdownId={openDropdownId}
            handleEditModalOpen={handleEditModalOpen}
            handlePreviewModalOpen={handlePreviewModalOpen}
            handleDeleteModalOpen={handleDeleteModalOpen}
          />
        </div>
      </div>

      {isAddModalOpen && (
        <AddProductCategoryAttributeValueModal
          isAddModalOpen={isAddModalOpen}
          toggleModal={toggleAddModal}
          handleAddValue={fetchValues}
        />
      )}

      {isEditModalOpen && (
        <EditProductCategoryAttributeValueModal
          isEditModalOpen={isEditModalOpen}
          toggleModal={toggleEditModal}
          selectedValue={selectedValue}
          fetchValues={fetchValues}
        />
      )}

      {isPreviewModalOpen && (
        <PreviewProductCategoryAttributeValueModal
          isPreviewModalOpen={isPreviewModalOpen}
          toggleModal={togglePreviewModal}
          selectedValue={selectedValue}
        />
      )}

      {isDeleteModalOpen && (
        <DeleteProductCategoryAttributeValueModal
          isDeleteModalOpen={isDeleteModalOpen}
          toggleModal={toggleDeleteModal}
          handleDelete={handleDelete}
          selectedValue={selectedValue}
        />
      )}
    </>
  );
};

export default ProductCategoryAttributeValueManagement;
